import { Button } from '@/components/Button';
import { YearPicker } from '@/components/YearPicker';
import { useUserData } from '@/contexts/UserDataContext';
import { Slide1Template } from '@/templates/Slide1Template';
import { convertFileToDataUrl } from '@/utils/utils';
import { useCallback, useEffect, useState } from 'react';
import { SmallLoader } from '../../components/SmallLoader';
import { TemplateOnScreenDisplay } from '../../components/TemplateOnScreenDisplay';

interface YearSelectionStepProps {
    onNext: () => void;
    initialYear?: number;
}

export const YearSelectionStep = ({ onNext, initialYear = new Date().getFullYear() }: YearSelectionStepProps) => {
    const { userData, updateUserData } = useUserData();
    const [selectedYear, setSelectedYear] = useState<number>(initialYear);
    const [photoDataUrl, setPhotoDataUrl] = useState<string | undefined>(userData.photoDataUrl);

    useEffect(() => {
        const convertPhotoToDataUrl = async () => {
            if (userData.selectedPhoto && !userData.photoDataUrl) {
                const dataUrl = await convertFileToDataUrl(userData.selectedPhoto);
                setPhotoDataUrl(dataUrl);
                // Update the context with the converted photo data URL
                updateUserData({ photoDataUrl: dataUrl });
            } else if (userData.photoDataUrl) {
                setPhotoDataUrl(userData.photoDataUrl);
            }
        };

        convertPhotoToDataUrl();
    }, [userData.selectedPhoto, userData.photoDataUrl, updateUserData]);

    const handleYearChange = useCallback((year: number) => {
        setSelectedYear(year);
        console.log('OCD year selected:', year);
    }, []);

    const handleYearConfirm = useCallback(() => {
        updateUserData({ ocdYear: selectedYear });
        onNext();
    }, [selectedYear, onNext, updateUserData]);

    return (
        <>
            <div className='flex flex-col justify-center items-center w-full overflow-y-auto overflow-x-hidden px-4'>
                <TemplateOnScreenDisplay className="flex-shrink-0">
                    {photoDataUrl ? <Slide1Template showText1Placeholder text1='' imageUrl={photoDataUrl} /> : <SmallLoader />}
                </TemplateOnScreenDisplay>

            </div>
            <div className="flex flex-col gap-6 items-center w-full px-8">
                <YearPicker value={selectedYear} onChange={handleYearChange} />
                <Button label="Confirm Year" onClick={handleYearConfirm} />
            </div>
        </>
    );
};
